import { GenderEnum } from './reach/reach.models';
import { ChartColors, WeatherColors } from './statistics.model';

export const PEOPLE_COLORS = {
  men: ChartColors.Primary,
  menCompare: ChartColors.PrimaryLight,
  women: ChartColors.Secondary,
  womenCompare: ChartColors.SecondaryLight,
  otsCompare: ChartColors.PrimaryDark,
  ots: ChartColors.SecondaryDark,
  white: ChartColors.White,
};

export const VEHICLE_COLORS = {
  cars: ChartColors.Quaternary,
  trucks: ChartColors.SecondaryDark,
  vans: ChartColors.Tertiary,
  busses: ChartColors.Gray,
  carsCompare: ChartColors.QuaternaryLight,
  trucksCompare: ChartColors.SecondaryLight,
  vansCompare: ChartColors.TertiaryLight,
  bussesCompare: ChartColors.GrayLight,
};

export const CHART_COLORS = {
  Primary: ChartColors.Primary,
  PrimaryLight: ChartColors.PrimaryLight,
  PrimaryDark: ChartColors.PrimaryDark,
  Secondary: ChartColors.Secondary,
  SecondaryLight: ChartColors.SecondaryLight,
  SecondaryDark: ChartColors.SecondaryDark,
  Tertiary: ChartColors.Tertiary,
  TertiaryLight: ChartColors.TertiaryLight,
  TertiaryDark: ChartColors.TertiaryDark,
  Quaternary: ChartColors.Quaternary,
  QuaternaryLight: ChartColors.QuaternaryLight,
  QuaternaryDark: ChartColors.QuaternaryDark,
  Gray: ChartColors.Gray,
  GrayLight: ChartColors.GrayLight,
  GrayDark: ChartColors.GrayDark,
  White: ChartColors.White,
};

export const WEATHER_COLORS = {
  Cold: WeatherColors.Cold,
  Cool: WeatherColors.Cool,
  Warm: WeatherColors.Warm,
  Hot: WeatherColors.Hot,
};

enum chartStyle {
  fluid = 0,
  abrupt = undefined,
}

// A variable that can have 0 if we want the chart to fall down to 0 if no data is available for the hour
// or undefined to have the chart end at the last data point
export const CHART_STYLE: chartStyle = chartStyle.fluid;

export const PEOPLE_TARGET_GROUPS = [
  { label: 'peopleCount.targetGroups.under18', gender: GenderEnum.Female, value: 1 },
  { label: 'peopleCount.targetGroups.18-24', gender: GenderEnum.Female, value: 2 },
  { label: 'peopleCount.targetGroups.25-34', gender: GenderEnum.Female, value: 3 },
  { label: 'peopleCount.targetGroups.35-44', gender: GenderEnum.Female, value: 4 },
  { label: 'peopleCount.targetGroups.45-54', gender: GenderEnum.Female, value: 5 },
  { label: 'peopleCount.targetGroups.55-64', gender: GenderEnum.Female, value: 6 },
  { label: 'peopleCount.targetGroups.65+', gender: GenderEnum.Female, value: 7 },
  { label: 'peopleCount.targetGroups.under18', gender: GenderEnum.Male, value: 8 },
  { label: 'peopleCount.targetGroups.18-24', gender: GenderEnum.Male, value: 9 },
  { label: 'peopleCount.targetGroups.25-34', gender: GenderEnum.Male, value: 10 },
  { label: 'peopleCount.targetGroups.35-44', gender: GenderEnum.Male, value: 11 },
  { label: 'peopleCount.targetGroups.45-54', gender: GenderEnum.Male, value: 12 },
  { label: 'peopleCount.targetGroups.55-64', gender: GenderEnum.Male, value: 13 },
  { label: 'peopleCount.targetGroups.65+', gender: GenderEnum.Male, value: 14 },
];
